import cls from "classnames";
import { Link } from "react-router-dom";

export default function ProductVariationSelect({
  variationOptions = [],
  onSelect,
}) {
  const variationValue = (variationValue, key) => {
    return (
      <Link
        key={key}
        type="button"
        className={cls(
          "btn  items-center whitespace-nowrap rounded px-4 py-1 text-small",
          {
            "hover-bg-main-600 hover-text-white": variationValue.isSelected,
            "bg-light-grey text-medium-electric-blue":
              !variationValue.isSelected && variationValue.isSelectable,
            "cursor-not-allowed option_fade":
              !variationValue.isSelected && !variationValue.isSelectable,
          }
        )}
        onClick={() =>
          variationValue.isSelectable &&
          onSelect(variationValue.id, variationValue.attribute_definition_id)
        }
      >
        {variationValue.value} {variationValue.unit}
      </Link>
    );
  };

  return variationOptions.map((variation, vKey) => (
    <div key={vKey} className="w-full border-medium-grey flex items-center">
      <span className="min-w-[90px]  px-4 flex items-center">
        {variation.name}
      </span>
      <span className="flex">
        {variation.options.map((value, index) => (
          <span key={index} className="inline-block">
            {variationValue(value)}&nbsp;&nbsp;
          </span>
        ))}
      </span>

      <span className="mt-16 pt-16 text-gray-700 border-top border-gray-100 d-block" />
    </div>
  ));
}
